import { render, staticRenderFns } from "./ModalMoveActivity.vue?vue&type=template&id=18be3368&lang=html&"
import script from "./ModalMoveActivity.vue?vue&type=script&lang=ts&"
export * from "./ModalMoveActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports